












































































































import { Component, Vue } from 'vue-property-decorator';
import API from '@/Api';
import { constants } from 'http2';

@Component
export default class PerformanceAppraisal extends Vue {
  public selfSubmit: boolean = false;
  public managerSubmit: boolean = false;
  public reviewerSubmit: boolean = false;

  public data1: any = [];
  public rating: string = "";
	public review: string = "";
  
  public id: any = null;
  public performancereviewid: any=null;
  public items: any[] = [];
  public item: any = null;
  public title: string = '';

  public designation: string = '';
  
  public quartercycle: string = '';
  public qyear: string = '';

  public OverallRatingByReviewer: string = '';
  public OverallCommentByReviewer: string = '';
  public reqempid: string = '';
  public Status: string = '';


  public userreviewstatus: string = '';

  public employeename: string = '';
  public incrementCycle: string = '';
  public cellBorders: any[] = [
    'cell-border-1',
    'cell-border-2',
    'cell-border-3',
    'cell-border-4',
    'cell-border-5',
  ];
  public list1: any = [];
  public list2: any = [];
  public list3: any = [];


  public created() {
   
  }

  public mounted() {
    this.id = this.$route.params.id;
    
      this.loadData();
   console.log(this.id);
  }

  public loadData() {
    API.Instance.get('api/goalsettings/FillgetReviewerratingInfo?id='+this.id).then((response) => {
      this.item = response.data;          
      this.title = this.item[0].employeename;
      this.reqempid = this.item[0].employeeid;
      this.userreviewstatus=this.item[0].status;
      this.OverallCommentByReviewer = this.item[0].overallcommentbyreviewer;
      this.OverallRatingByReviewer=this.item[0].overallratingbyreviewer;
      console.log("test"+response.data[0].employeename);
      
    });
    
  }

 
  
  
  
  
  public Assesmentsubmit() {

   

    window.dialog
      .open('Are you sure?', 'You can not resubmit again')
      .then((dialogResult: any) => {
        if (dialogResult === true) {
      
        
		this.data1 = {
			overallratingbyreviewer:this.item[0].overallratingbyreviewer,
			overallcommentbyreviewer: this.item[0].overallcommentbyreviewer,
      reqempid: this.id
		};
		console.log(this.data1);
		API.Instance.post(
      '/api/goalsettings/addreviewerfinalrating',this.data1
    ).then((response) => {
		
   console.log(response);
      this.$store.commit('AppStore/SNACK_BAR', {
        text: response.data,
        show: true,
      });
	  
	  setTimeout(() => {
      window.location.href='/reviewer-assesment';
    }, 1000);
	  
    });
	   
	   
	   
        }
      });
	  

  }




}
